<div class="ui-g flight-leg" [formGroup]="entry">
  <div class="leg-delete-overlay" *ngIf="showDeleteOverlay"></div>
  <div class="ui-g-12 ui-g-nopad">
    <div class="ui-g">
      <div class="ui-g-12 ui-g-nopad leg-container">
        <fieldset>
          <legend *ngIf="formHelper.isEntryPerLeg">
            Leg {{ entryIndex + 1 }}
            <span *ngIf="(fromWaypoint$ | async)?.description; let fromDescription">
              <span *ngIf="(toWaypoint$ | async)?.description; let toDescription"
                >: {{ fromDescription }} to {{ toDescription }}</span
              >
            </span>
          </legend>
          <div data-row-span="12">
            <div
              data-field-span="3"
              *ngIf="!formHelper.isEntryPerLeg"
              [flValidationState]="entry.get('flightTime')"
            >
              <label>Departure Time</label>
              <kendo-dateinput
                [format]="dateTimeFormat"
                [formControl]="entry.get('flightTime')"
              ></kendo-dateinput>
            </div>
            <span formGroupName="entryDetail">
              <div data-field-span="6" formGroupName="attributes">
                <label>Flight Rules/Procedures</label>
                <label> <input type="checkbox" formControlName="nvg" />&nbsp;NVG</label>
                &nbsp;
                <label *ngIf="!formHelper.isSimple">
                  <input type="checkbox" formControlName="refueled" />&nbsp;Refueled</label
                >
                &nbsp;
                <!--
                  INFO: hiding extra miles checkbox, until ready to be used
                -->
                <!--
                  <label><input type="checkbox" formControlName="hasExtraMileage">&nbsp;Extra Miles</label>
                -->
              </div>
              <div
                data-field-span="1"
                *ngIf="!formHelper.isSimple && isFixedWing$ | async"
                flValidationState="cabinTemperature"
              >
                <label>Cabin Temperature</label>
                <input type="number" formControlName="cabinTemperature" />
              </div>
              <div
                data-field-span="1"
                *ngIf="!formHelper.isSimple && isFixedWing$ | async"
                flValidationState="maxAltitude"
              >
                <label>Max Cabin Altitude</label>
                <input type="number" formControlName="maxAltitude" />
              </div>
            </span>
          </div>
          <fl-message-box [messages]="legErrors$ | async" [level]="'error'"></fl-message-box>
          <span formGroupName="entryDetail">
            <div data-row-span="12">
              <fl-flight-leg-crew-member
                *ngFor="let crewMember of formHelper.flightCrew$ | async"
                [crewMember]="crewMember"
                [crewMemberAboard]="getCrewMemberAboard$(crewMember.id) | async"
                (onboard)="onboard(crewMember.id)"
                (disboard)="disboard(crewMember.id)"
                [enableNvg]="nvgSelected$ | async"
                [formHelper]="formHelper"
              ></fl-flight-leg-crew-member>
              <div data-field-span="2" *ngIf="!formHelper.isSimple">
                <label>Patient</label>
                <label>
                  <input type="checkbox" formControlName="isPatientOnboard" />&nbsp;Aboard</label
                >
              </div>
              <ng-container *ngIf="isFixedWing$ | async">
                <div data-field-span="1" flValidationState="passengerCount">
                  <label># Passengers</label>
                  <input type="number" min="0" formControlName="passengerCount" />
                </div>
                <div data-field-span="1" flValidationState="totalLoadedWeightInKg">
                  <label>TLW (kg)</label>
                  <input type="number" min="0" step="0.5" formControlName="totalLoadedWeightInKg" />
                </div>
              </ng-container>
              <div data-field-span="1" flValidationState="actIndex">
                <label>Act Index</label>
                <input type="number" min="0" step="0.5" formControlName="actIndex" />
              </div>
            </div>
            <div
              data-row-span="12"
              *ngIf="fromWaypoint && entryIndex === 0"
              [formGroup]="fromWaypoint"
            >
              <div data-field-span="3" flValidationState="departureTime">
                <label>Departure Time</label>
                <kendo-dateinput
                  [format]="dateTimeFormat"
                  formControlName="departureTime"
                ></kendo-dateinput>
              </div>
              <div data-field-span="5" flValidationState="description">
                <label>From</label>
                <input type="text" formControlName="description" />
              </div>
              <div data-field-span="2" formGroupName="coordinate">
                <label>Lat</label>
                <input type="number" formControlName="latitude" />
              </div>
              <div data-field-span="2" formGroupName="coordinate">
                <label>Lon</label>
                <input type="number" formControlName="longitude" />
              </div>
            </div>
            <div
              data-row-span="12"
              *ngIf="fromWaypoint && entryIndex > 0"
              [formGroup]="fromWaypoint"
            >
              <div data-field-span="3" flValidationState="departureTime">
                <label>Departure Time</label>
                <kendo-dateinput
                  [format]="dateTimeFormat"
                  formControlName="departureTime"
                ></kendo-dateinput>
              </div>
              <div data-field-span="5" class="readonly">
                <label>From</label>
                <input type="text" readonly [value]="(fromWaypoint$ | async).description" />
              </div>
              <div data-field-span="2" class="readonly">
                <label>Lat</label>
                <input
                  type="number"
                  readonly
                  [value]="(fromWaypoint$ | async).coordinate.latitude"
                />
              </div>
              <div data-field-span="2" formGroupName="coordinate" class="readonly">
                <label>Lon</label>
                <input
                  type="number"
                  readonly
                  [value]="(fromWaypoint$ | async).coordinate.longitude"
                />
              </div>
            </div>
            <div data-row-span="12" *ngIf="toWaypoint" [formGroup]="toWaypoint">
              <div data-field-span="3" flValidationState="arrivalTime">
                <label>Arrival Time</label>
                <kendo-dateinput
                  [format]="dateTimeFormat"
                  formControlName="arrivalTime"
                ></kendo-dateinput>
              </div>
              <div data-field-span="5" flValidationState="description">
                <label>To</label>
                <input type="text" formControlName="description" />
              </div>
              <div data-field-span="2" formGroupName="coordinate">
                <label>Lat</label>
                <input type="number" formControlName="latitude" />
              </div>
              <div data-field-span="2" formGroupName="coordinate">
                <label>Lon</label>
                <input type="number" formControlName="longitude" />
              </div>
            </div>
          </span>
          <fl-message-box [messages]="waypointErrors$ | async" [level]="'error'"></fl-message-box>
          <br />
          <div formArrayName="pilotLogEntries">
            <div
              *ngFor="let pilotLogEntry of entry?.get('pilotLogEntries')?.controls; let i = index"
              [formGroupName]="i"
            >
              <fl-pilot-log-entry
                [formHelper]="formHelper"
                [pilotLogEntry]="pilotLogEntry"
                [pilot]="getCrewMemberById(pilotLogEntry.value.flightCrewId)"
              ></fl-pilot-log-entry>
            </div>
          </div>
          <div>
            <br />
            <fl-billing-summary
              *ngIf="hasExtraMileage$ | async"
              [billingSummary]="entry.get('entryDetail.billingSummary')"
            ></fl-billing-summary>
          </div>
          <div *ngIf="refueledSelected$ | async; let refueledSelected" formGroupName="entryDetail">
            <br />
            <fieldset formArrayName="fuelEvents">
              <legend>Refuelings</legend>
              <fl-fuel-event
                *ngFor="let fuelEvent of (fuelEvents$ | async).controls; let i = index"
                [formGroupName]="i"
                [fuelEvent]="fuelEvent"
              ></fl-fuel-event>
              <div class="fuel-event-actions" *ngIf="formHelper.isEntryPerFlight">
                <button type="button" mat-raised-button class="mini" (click)="addFuelEvent()">
                  <mat-icon>add</mat-icon> Add Refueling Event
                </button>
              </div>
            </fieldset>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>
<div class="leg-actions" *ngIf="formHelper.isEntryPerLeg && canDisplayLegActions">
  <button class="delete-leg" mat-raised-button *ngIf="entryIndex == 0" (click)="resetLegs.emit()">
    <mat-icon>clear</mat-icon>
    Reset Legs
  </button>

  <button
    (mouseover)="onDeleteMouseover()"
    (mouseleave)="onDeleteMouseleave()"
    class="delete-leg"
    mat-raised-button
    *ngIf="entryIndex !== 0 && formHelper.canRemoveLogEntry(entryIndex)"
    (click)="delete.emit()"
  >
    <mat-icon>delete</mat-icon>
    Delete
  </button>

  <button (click)="formHelper.addLogEntry(entryIndex + 1)" type="button" mat-raised-button>
    <mat-icon>add</mat-icon> {{ addActionText }} Leg
  </button>
</div>
